import React, {useContext} from 'react'
import {Collapse} from "@material-ui/core";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import getObjectValue from "libs/getObjectValue";


function QualificationData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)


    return (<>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("predictedExclusion")}
            required
        />
        <Collapse in={gVal("predictedExclusion") === true}>
            <NoticeGlossaryInput
                id={gId("predictedExclusionInfo")}
                formikProps={formikProps}
                items={getDict("SL.MO.028")}
                multiple
                required
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("participationConditions")}
            required
        />
        <Collapse in={gVal("participationConditions") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("participationConditionsInfo")}
                multiline
                required
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("art125Statement")}
            required
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("inclusionSubjectiveEvidence")}
            multiline
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("exclusionSubjectiveEvidence")}
            multiline
        />

    </>)
}

QualificationData.propTypes = {};

export default QualificationData;
